"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormulaBody["default"];
  }
});
var _FormulaBody = _interopRequireDefault(require("./FormulaBody"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }